
//import 'sweetalert2/dist/sweetalert2.min.css';
//import '@sweetalert2/themes/material-ui/material-ui.min.css';

//import 'styles/webstore/fontawesome.scss';
//import 'styles/webstore/tailwind.css';
//import 'styles/webstore/webstore.scss';

import Vue from 'vue';

// configure routing/app store
import router from 'frontend/router';
import store from 'frontend/store';

// import shell component
import WebstoreMain from 'frontend/shell/comp/WebstoreMain.vue';

// import main functionality
import 'frontend/ux';
import 'frontend/customize';
import 'frontend/cart';
import 'frontend/checkout';
import 'frontend/profile';

// initialize shell data
store.commit('shell/setProductOptionTypes', window._initData.productOptionTypes);
store.commit('shell/setCurrentUser', window._initData.currentUser);

// initialize main vue instance
const app = new Vue({
	el: '#app-root',
	router,
	store,

	render(h) {
		return h(WebstoreMain);
	}
});